var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import history from "@irati/utils/history";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import intercom from "@irati/utils/intercom";
import { FormattedMessage } from "@irati/utils/lang";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Hr from "@irati/ui/src/Layout/Hr";
import Flex from "@irati/ui/src/Flex";
import { Firstname, Lastname, Email } from "@irati-web/fields/user";
import usersService from "@irati/identity/services/users";
import Loading from "@irati/ui/src/Loading";
import Button from "@irati/ui/src/Button";
import successImage from "@irati/ui/images/success.svg";
import Routes, { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import Form from "@irati/ui/src/Form";
import authentication from "@irati/auth";
import { Content, Container } from "../StepContent/styled";
import { MaxWContent, Img, MarginButton } from "./styled";
import Header from "./Header";
var InviteAdmin = /** @class */ (function (_super) {
    __extends(InviteAdmin, _super);
    function InviteAdmin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            firstname: "",
            lastname: "",
            email: "",
            load: null,
            success: false
        };
        // If the user came from a setup step, send them back else send to the first uncompleted step
        _this.handleGoBack = function () {
            var _a, _b, _c;
            var basePath = Routes[SETUP_TENANT];
            var lastVisitedStepPath = (_c = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.lastVisitedStepPath;
            if (lastVisitedStepPath) {
                history.push("" + basePath + lastVisitedStepPath);
            }
            else {
                history.push(basePath);
            }
        };
        // Ensure the intercom help bubble is not shown
        _this.componentWillMount = function () { return intercom.hide(); };
        _this.componentWillUnmount = function () { return intercom.show(); };
        _this.createAdmin = function () {
            var _a = _this.state, firstname = _a.firstname, lastname = _a.lastname, email = _a.email;
            var user = {
                businessId: authentication.userTenant().uuid,
                firstName: firstname,
                lastName: lastname,
                email: email,
                language: authentication.userLocale()
            };
            var load = usersService.create({ user: user }).then(function (createdUser) {
                return usersService.makeUserGlobalAdmin(createdUser.uuid);
            }).then(function () { return _this.setState({ success: true }); });
            _this.setState({ load: load });
        };
        _this.updateInput = function (label, value) {
            var _a;
            // @ts-ignore
            _this.setState((_a = {},
                _a[label] = value,
                _a));
        };
        return _this;
    }
    InviteAdmin.prototype.render = function () {
        var _this = this;
        var _a = this.state, firstname = _a.firstname, lastname = _a.lastname, email = _a.email, load = _a.load, success = _a.success;
        if (success)
            return (React.createElement(Container, null,
                React.createElement(Content, null,
                    React.createElement(Header, null),
                    React.createElement(Img, { src: successImage }),
                    React.createElement(H3, { tiny: true },
                        React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.success.title" })),
                    React.createElement(Para, null,
                        React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.success.description" })),
                    React.createElement(Button, { onClick: this.handleGoBack },
                        React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.button.back" })))));
        return (React.createElement(Container, null,
            React.createElement(Content, null,
                React.createElement(Form, null,
                    React.createElement(Header, null),
                    React.createElement(MaxWContent, { maxWidth: "400px" },
                        React.createElement(Firstname, { value: firstname, onChange: function (value) { return _this.updateInput("firstname", value); } }),
                        React.createElement(Lastname, { value: lastname, onChange: function (value) { return _this.updateInput("lastname", value); } })),
                    React.createElement(MaxWContent, { maxWidth: "700px" },
                        React.createElement(Email, { value: email, onChange: function (value) { return _this.updateInput("email", value); } }),
                        React.createElement(Hr, null),
                        React.createElement(Para, { bold: true },
                            React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.tip.header" })),
                        React.createElement(Para, null,
                            React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.tip.text" }))),
                    React.createElement(Flex, { direction: "column" },
                        React.createElement(Loading, { load: load, useLoader: false }),
                        React.createElement(Flex, { direction: "row" },
                            React.createElement(ValidationButton, { primary: true, load: load, onClick: this.createAdmin },
                                React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.button.text" })),
                            React.createElement(MarginButton, { onClick: this.handleGoBack },
                                React.createElement(FormattedMessage, { id: "setup_tenant.inviteAdmin.button.back" }))))))));
    };
    return InviteAdmin;
}(PureComponent));
export default InviteAdmin;
